import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterCubicCapacitySearchValueObject extends ValueObject {
  #cubicCapacity

  constructor({cubicCapacity}) {
    super()
    this.#cubicCapacity = cubicCapacity
  }

  static create({cubicCapacity}) {
    return new FilterCubicCapacitySearchValueObject({cubicCapacity: FilterRangeSearchValueObject.create(cubicCapacity)})
  }

  static createWithDefaultValue({config, cubicCapacity}) {
    const {DEFAULT_CUBIC_CAPACITY_SEARCH} = config.get('searchFilters')

    return new FilterCubicCapacitySearchValueObject({
      cubicCapacity: FilterRangeSearchValueObject.create({
        from: cubicCapacity?.from || DEFAULT_CUBIC_CAPACITY_SEARCH.from,
        to: cubicCapacity?.to || DEFAULT_CUBIC_CAPACITY_SEARCH.to
      })
    })
  }

  static createQueryParams({config, cubicCapacity}) {
    const {DEFAULT_CUBIC_CAPACITY_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterCubicCapacitySearchValueObject({
      cubicCapacity: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LITRES].from,
          value: cubicCapacity?.from || DEFAULT_CUBIC_CAPACITY_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.LITRES].to,
          value: cubicCapacity?.to || DEFAULT_CUBIC_CAPACITY_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#cubicCapacity.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#cubicCapacity.from.isEmpty && {...this.#cubicCapacity.from.queryParam}),
      ...(!this.#cubicCapacity.to.isEmpty && {...this.#cubicCapacity.to.queryParam})
    }
  }

  get value() {
    return this.#cubicCapacity.value
  }

  toJSON() {
    return {
      cubicCapacity: this.#cubicCapacity.toJSON()
    }
  }
}
